import {
  ADD_VIDEO,
  SET_VIDEO_UPLOADING_STATUS,
  DELETE_VIDEO,
  CLEAR_VIDEOS_STATE
} from './mutations-types'

export default {
  [ADD_VIDEO] (state, videos) {
    state.videos.push(videos)
  },
  [SET_VIDEO_UPLOADING_STATUS] (state, payload) {
    state.videoUploadingInProgress = payload
  },
  [DELETE_VIDEO] (state, id) {
    state.videos = state.videos.filter(video => video.id !== id)
  },
  [CLEAR_VIDEOS_STATE] (state) {
    state.videos = []
  }
}
